import WOW from 'wow.js';
let isBurger = false;
$('#burger-nav').on('click', function(e) {
  if(!isBurger) {
    isBurger = true;
    $('.burger__line').toggleClass('opened');
    $('.header__nav-overlay').toggleClass('header__nav-overlay-open');
    $('body').toggleClass('unscroll');

    setTimeout(function() { isBurger = false; }, 500);
  }
    
});
var lastScrollTop = 0;
var rellax1 = 0;
var rellax2 = 0;
window.onscroll = function(e) {
  
  var scrolled = window.pageYOffset || document.documentElement.scrollTop;
  
  let scrollDown = $('.scroll-down');
  
  if(scrolled > 250) {
    scrollDown.css('opacity', 0);
  }else{
    scrollDown.css('opacity', 1);
  }

  var float1 = document.getElementById('float-1');
  var float2 = $('#float-2');

  

  // if(window.isAnyPartOfElementInViewport(float1)) {
    
  //   var st = $(this).scrollTop();
  //   if (st > lastScrollTop) {
  //     rellax1 += st - lastScrollTop;
  //   } else {
  //     rellax1 -= st - lastScrollTop;
  //   }
  //   lastScrollTop = st;

  //   $(float1).find('.section-floating__left').css({'transform':'translate(0px,' + rellax1/2 * 0.3 + 'px)'});
  //   $(float1).find('.section-floating__middle').css({'transform':'translate(0px,' + rellax1/2 * 0.8 + 'px)'});
  //   $(float1).find('.section-floating__right').css({'transform':'translate(0px,' + rellax1/2 * 0.3 + 'px)'});

  // }

};



window.isAnyPartOfElementInViewport = function(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document. documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document. documentElement.clientWidth)
  );
};

new WOW( {mobile: false }).init();